import { useNavigate } from "react-router";
import classes from "./Errorboundary.module.css";
import CommonButton from "./Buttons/CommonButton";
import fournotfoundgif from "../Assests/Images/Oops404Errorwithabrokenrobot.gif";

export default function Errorboundary() {
  const navigate = useNavigate();

  return (
    <>
      {/* <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Back Home
          </Button>
        }
      /> */}
      {/* <div className={classes.error_page_background}> */}
      <div className={classes.container}>
        <div className={classes.Content}>
          <img
            src={fournotfoundgif}
            alt={"404gif"}
            style={{ maxWidth: "100%" }}
          />
          {/* <p className={classes.fournotfour_text}>404</p>
            <p className={classes.page_not_found}>Page Not Found</p> */}
          <div>
            <p>We're sorry,the page you requested could not be found</p>
            <p>Please go back to homepage</p>
          </div>

          <CommonButton
            name="Go back to home"
            onClick={() => navigate("/dashboard")}
            type="nutton"
            style={{
              padding: "6px 24px",
              maxWidth: "173px",
              height: "44px",
              borderRadius: "10px",
              backgroundColor: "#F8CA00",
              fontWeight: "500",
            }}
          />
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
